import React from 'react';
import Styles from './WebfitButton.module.scss';

const Button = (props) => {
  const {
    label, invertStyling, onClick, iconBefore, iconAfter, disabled,
  } = props;
  return (
    <button
      className={`
      ${Styles.btn}
      ${invertStyling && Styles.invert}
      ${disabled && Styles.disabled}
      `}
      onClick={() => onClick && onClick()}
      disabled={disabled}
      type="button"
    >
      {iconBefore && <img src={iconBefore} />}
      {label}
      {iconAfter && <img src={iconAfter} />}
    </button>
  );
};

export default Button;
